<template>
  <blockquote v-if="notes?.length > 0" class="note-block">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="formattedNotes" />
    <cite v-if="author && timestamp">
      - {{ author }}, {{ formatDate(timestamp, 'MMM dd, h:mm a') }}
    </cite>
  </blockquote>
  <em v-else>No notes yet</em>
</template>

<script setup>
import { formatDate } from 'date-fns'
import { toRef } from 'vue'

import { useFormattedContent } from '@/6_shared/composables/useFormattedContent'

const props = defineProps({
  notes: { type: String, default: '' },
  author: { type: String, default: '' },
  timestamp: { type: Number, default: 0 },
})

const formattedNotes = useFormattedContent(toRef(props, 'notes'))
</script>

<style scoped>
.note-block {
  background: #f5f5f5;
  border-left: 4px solid var(--ion-color-primary);
  margin: 0;
  padding: 1em;
}

:deep(.note-block div p:first-child) {
  margin-top: 0;
}

.note-block cite {
  display: block;
  margin-top: 0.5em;
  font-size: 0.9em;
  color: var(--ion-color-medium);
}
</style>
